import { Component, EventEmitter, inject, Input, ViewEncapsulation } from '@angular/core';
import { AgentRetakeDocumentComponent } from '@components/agent-retake-document/agent-retake-document.component';
import { SessionFailedReasonComponent } from '@components/session-failed-reason/session-failed-reason.component';
import { OverlayService } from '@services/overlay';
import { RetakeDocumentPayload } from 'src/app/interfaces/retake-document-payload.interface';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule, NgClass, DatePipe } from '@angular/common';
import { IconDirective } from '../../directives/icon.directive';
import { TokboxViewComponent } from '../tokbox-view/tokbox-view.component';
import { Identification, Session } from 'src/app/queries/generated';
import { Tokbox } from '@models/tokbox';

@Component({
  selector: 'lv-session-details',
  templateUrl: 'session-details.component.html',
  styleUrls: ['session-details.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, TranslateModule, NgClass, IconDirective, TokboxViewComponent, DatePipe]
})
export class SessionDetailsComponent {
  private overlayService = inject(OverlayService);
  private translate = inject(TranslateService);

  @Input() session: Session;
  @Input() tokbox: Tokbox;
  @Input() passed: EventEmitter<boolean>;
  @Input() failed: EventEmitter<string>;
  @Input() retaken: EventEmitter<RetakeDocumentPayload>;

  get learner() {
    return this.session.learner;
  }

  get identification(): Identification {
    return this.session.activeIdentification;
  }

  get tokboxEnabled(): boolean {
    return this.tokbox && !this.session.finished;
  }

  get translatedVerifyLabel(): string {
    return this.translate.instant('session-details.component.verify.' + this.verifyLabel());
  }

  pass() {
    this.passed.emit(true);
  }

  fail() {
    this.overlayService.open(SessionFailedReasonComponent, {
      submitted: this.failed,
      session: this.session
    });
  }

  onRetake() {
    this.overlayService.open(AgentRetakeDocumentComponent, {
      submitted: this.retaken,
      session: this.session
    });
  }

  passEnabled(): boolean {
    return this.session.can.pass;
  }

  failDisabled(): boolean {
    return this.session.failed || this.session.passed;
  }

  private verifyLabel(): string {
    return this.session.idVerified ? 'attendance' : 'id-photo';
  }
}
